import { useEffect, useState } from 'react'
import ImageNext from '@/components/ImageNext'

interface ImageWithFallback extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  fallbackSrc: string
  width?: number
  height?: number
  alt: string
  autoSize?: boolean
}

const ImageWithFallback = ({
  src,
  fallbackSrc,
  width,
  height,
  alt,
  autoSize,
  className,
  ...rest
}: ImageWithFallback) => {
  const [imgSrc, setImgSrc] = useState<string>(src)
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setImgSrc(src)
    setHasError(false)
    setIsLoading(true)
  }, [src])

  if (!src || !fallbackSrc) return null

  const handleError = () => {
    if (!hasError) {
      console.warn('Image failed, using fallback:', src)
      setHasError(true)
      setImgSrc(fallbackSrc)
      setIsLoading(true)
    } else {
      console.error('Fallback also failed:', fallbackSrc)
      setIsLoading(false)
    }
  }

  const handleLoad = () => {
    setIsLoading(false)
  }

  return (
    <ImageNext
      {...rest}
      src={imgSrc}
      width={width}
      height={height}
      alt={alt}
      autoSize={autoSize}
      onError={handleError}
      onLoad={handleLoad}
      className={['content-img', isLoading ? 'skeleton-img' : '', className]
        .filter(Boolean)
        .join(' ')}
    />
  )
}

export default ImageWithFallback
